import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Thumbnail from '../Thumbnail/Thumbnail';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { LAYOUTS } from 'store/modules/video-layout';
import { FILMSTRIP_TYPE } from 'store/modules/filmstrip';
const Filmstrip = (props) => {
  const { deviceParticipants, remoteParticipants, clientWidth, clientHeight } =
    props;
  let thumbnailHeight = 0;
  let thumbnailWidth = 0;

  const renderRemoteParticipants = useCallback(() => {
    const rows = [];
    let counter = 0;
    const length = remoteParticipants.length;
    const initial = clientHeight < 400 || length <= 4 ? length : 2;
    for (let i = initial; counter < length; i++) {
      rows.push(
        [...Array(i)].map(() => {
          if (counter < length) {
            const participantId = remoteParticipants[counter];
            counter++;
            return participantId;
          }
        })
      );
    }
    if (clientHeight > 400) {
      thumbnailHeight = Math.min(
        (clientHeight - 100) / (rows.length + 1),
        (clientHeight - 100) / 3
      );
      thumbnailWidth = Math.min(
        (clientWidth - 100) / initial,
        (clientWidth - 100) / 3
      );
      thumbnailHeight = Math.min(thumbnailHeight, thumbnailWidth);
    }
    return rows.map((item, index) => (
      <div
        key={index}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '8px'
        }}>
        {item.map(
          (participantId) =>
            participantId && (
              <div
                style={{ position: 'relative' }}
                key={`remote_${participantId}`}>
                <Thumbnail
                  _currentLayout={LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW}
                  filmstripType={FILMSTRIP_TYPE.MAIN}
                  noOnStage={true}
                  participantID={participantId}
                  style={{ position: 'relative' }}
                  width={thumbnailHeight}
                  height={thumbnailHeight}
                />
              </div>
            )
        )}
      </div>
    ));
  }, [remoteParticipants]);
  const renderDeviceParticipants = useCallback(() => {
    return deviceParticipants.map((item) => (
      <Thumbnail
        _currentLayout={LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW}
        filmstripType={FILMSTRIP_TYPE.MAIN}
        noOnStage={true}
        key={`remote_${item}`}
        participantID={item}
        style={{ position: 'relative' }}
        width={thumbnailHeight}
        height={thumbnailHeight}
      />
    ));
  }, [deviceParticipants]);
  return (
    <div className="filmstrip__videos" id="emptyRemoteVideos">
      <div className="emptystage">
        <div className="emptystage-column">{renderRemoteParticipants()}</div>
        <div className="emptystage-row">{renderDeviceParticipants()}</div>
      </div>
    </div>
  );
};
export default React.memo(withBoundary(Filmstrip));
Filmstrip.propTypes = {
  remoteParticipants: PropTypes.array,
  deviceParticipants: PropTypes.array,
  clientHeight: PropTypes.number,
  clientWidth: PropTypes.number
};
